import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useUpdateApplicationStatus = (): any => {
  const { data, isLoading, send } = useRequest({
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
  });

  const updateApplicationStatus = (body, applicationId, successFunction: any) => {
    send(body, `/api/v1/application/${applicationId}`).then((res) => {
      successFunction(res?.chatId);
    });
  };

  return {
    isLoading,
    updateApplicationStatus,
    data,
  };
};
